import Vue from 'vue'
import Vuex from 'vuex'

import state from "./state"
import getters from "./getters"
import mutations from "./mutations"
import actions from "./actions"

Vue.use(Vuex)

import moduleUserManagement from './user-management/moduleUserManagement'
import moduleTransactionManagement from './transaction-management/moduleTransactionManagement'
import moduleCategoryManagement from './categories-management/moduleCategoryManagement'



export default new Vuex.Store({
    getters,
    mutations,
    state,
    actions,
    modules:{
      moduleUserManagement,
      moduleTransactionManagement,
      moduleCategoryManagement
    },
    strict: process.env.NODE_ENV !== 'production'
})
